// extracted by mini-css-extract-plugin
export var attachment = "_k6-a";
export var emailContainer = "_k6-4";
export var emailContentPaddedContainer = "_k6-b";
export var emailHeader = "_k6-6";
export var emailIframe = "_k6-3";
export var emailInfoIcon = "_k6-9";
export var emailShortenedSummary = "_k6-e";
export var infoDropdown = "_k6-0";
export var infoRowBoundedContent = "_k6-d";
export var internal = "_k6-5";
export var merchant = "_k6-8";
export var messageInputContainer = "_k6-h";
export var normal = "_k6-7";
export var replyCard = "_k6-f";
export var subtleButton = "_k6-1";
export var subtleButtonIconContainer = "_k6-2";
export var toggleViewRepliesButton = "_k6-c";
export var wrappingText = "_k6-g";